export { OrderListPage } from './view/order-list-page';

export type { IOrderList, IDeliverySlot } from './types';
export { default as OrderSlice } from './slice';
export { OrderSagas } from './saga';
